<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});

const textDirection = computed(() => {
  const text = (props.content || '').trim();

  if (!text) return 'auto';

  return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text)
    ? 'rtl'
    : 'ltr';
});
</script>

<template>
  <span
  v-dompurify-html="formattedContent"
  class="prose prose-bubble"
  :dir="textDirection"
/>
</template>
